import type { BoxProps } from '@hover/blueprint';
import { Body, Box, Heading, Sheet } from '@hover/blueprint';
import React from 'react';

import { Button } from 'src/shared/components';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

import { useHomeownerAppContext } from '../../hooks';

interface DestructiveConfirmationProps extends BoxProps {
  deleteAction: () => void;
  closeAction?: () => void;
  headerText?: string;
  subHeaderText?: string;
  deleteText?: string;
  cancelText?: string;
  buttonLocation: string;
  trackId: string;
}

const DestructiveConfirmationBody = ({
  cancelText,
  deleteAction,
  deleteText,
  headerText,
  subHeaderText,
  closeAction,
  trackId,
  buttonLocation,
  ...rest
}: DestructiveConfirmationProps) => {
  const { trackingData, setCurrentMenu } = useHomeownerAppContext();
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  const handleCloseAction = () => {
    if (closeAction) closeAction();
    setCurrentMenu(null);
  };

  return (
    <Box flexDirection="column" width="100%" {...rest}>
      <Heading width="100%">
        {headerText ?? t('destructiveConfirmation.header')}
      </Heading>
      <Body maxW={750} pb={500}>
        {subHeaderText ?? t('destructiveConfirmation.subHeader')}
      </Body>
      <Box flexDirection="column" gap={200}>
        <Button
          backgroundColor="danger600"
          onClick={() => {
            deleteAction();
          }}
          optionalTrackingProperties={{
            ...trackingData,
            button_location: buttonLocation,
            track_id: trackId,
          }}
          width="100%"
        >
          {deleteText ?? t('destructiveConfirmation.delete')}
        </Button>
        <Button
          onClick={() => {
            handleCloseAction();
          }}
          optionalTrackingProperties={{
            ...trackingData,
            button_location: buttonLocation,
            track_id: `${trackId}-cancel`,
          }}
          variant="tertiary"
          width="100%"
        >
          {cancelText ?? t('destructiveConfirmation.cancel')}
        </Button>
      </Box>
    </Box>
  );
};

const DestructiveConfirmation = (props: DestructiveConfirmationProps) => (
  <Sheet.Contents contentKey="delete-confirmation">
    <DestructiveConfirmationBody {...props} />
  </Sheet.Contents>
);

export { DestructiveConfirmation };
